import { TranslateModule } from '@ngx-translate/core'
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListStatusComponent } from './list-status.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
	declarations: [ListStatusComponent],
	exports: [ListStatusComponent],
	imports: [
		CommonModule,
		FlexLayoutModule,
		TranslateModule
	],
})
export class ListStatusModule { }
